import { IconProps } from "../../types/genereal";
import { IconWrapper } from "../ui/IconWrapper";

export const InfoIcon = ({
  width = "24",
  height = "24",
  color = "#1C3C6C",
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.666 17.4993H13.3327V15.8327H11.666V17.4993ZM12.4993 4.16602C11.405 4.16602 10.3214 4.38156 9.31032 4.80035C8.29927 5.21914 7.38061 5.83297 6.60679 6.60679C5.04399 8.1696 4.16602 10.2892 4.16602 12.4993C4.16602 14.7095 5.04399 16.8291 6.60679 18.3919C7.38061 19.1657 8.29927 19.7796 9.31032 20.1983C10.3214 20.6171 11.405 20.8327 12.4993 20.8327C14.7095 20.8327 16.8291 19.9547 18.3919 18.3919C19.9547 16.8291 20.8327 14.7095 20.8327 12.4993C20.8327 11.405 20.6171 10.3214 20.1983 9.31032C19.7796 8.29927 19.1657 7.38061 18.3919 6.60679C17.6181 5.83297 16.6994 5.21914 15.6884 4.80035C14.6773 4.38156 13.5937 4.16602 12.4993 4.16602ZM12.4993 19.166C8.82435 19.166 5.83268 16.1743 5.83268 12.4993C5.83268 8.82435 8.82435 5.83268 12.4993 5.83268C16.1743 5.83268 19.166 8.82435 19.166 12.4993C19.166 16.1743 16.1743 19.166 12.4993 19.166ZM12.4993 7.49935C11.6153 7.49935 10.7674 7.85054 10.1423 8.47566C9.5172 9.10078 9.16602 9.94863 9.16602 10.8327H10.8327C10.8327 10.3907 11.0083 9.96673 11.3208 9.65417C11.6334 9.34161 12.0573 9.16602 12.4993 9.16602C12.9414 9.16602 13.3653 9.34161 13.6779 9.65417C13.9904 9.96673 14.166 10.3907 14.166 10.8327C14.166 12.4993 11.666 12.291 11.666 14.9993H13.3327C13.3327 13.1243 15.8327 12.916 15.8327 10.8327C15.8327 9.94863 15.4815 9.10078 14.8564 8.47566C14.2312 7.85054 13.3834 7.49935 12.4993 7.49935Z"
          fill={color}
        />
      </svg>
    </IconWrapper>
  );
};
